<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-content>
    <nf-table-layout
      hideTitle
      [autoResizeGrid]="false"
      isSectionTitle="true"
      [data]="priceData"
      [gridOptions]="gridOptions"
      hideClearAll
    ></nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
<div *ngIf="securityIdsWithoutData.length">
  <p>*Securities without data: {{ securityIdsWithoutData }}</p>
</div>
<div *ngIf="lastPricingRunDate.length">
  <p>*Last Pricing Ran On: {{ lastPricingRunDate }}, *Price: {{ lastPrice }}</p>
</div>
